import type { IPublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from "@/config/authConfig";
import { ROUTES } from "@routing/routes";

// Bug #301: by default MSAL navigates back to the page that INITIATED the
// login (navigateToLoginRequestUrl=true), so signing in from the homepage
// or a marketing page dropped users right back there. Sign In controls
// should land users in the app instead — customers on /c/browse, the admin
// surface on /a. redirectStartPage overrides only that post-login
// destination; the registered redirectUri is untouched. Deep-link logins
// are handled by ProtectedRoute, which passes an explicit redirectUri —
// don't use this helper there.
export const signInRedirect = (
    instance: IPublicClientApplication,
    startPage: string = ROUTES.BROWSE,
) =>
    instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: `${window.location.origin}${startPage}`,
    });
